import { Box, Text } from '@bottlebooks/gatsby-design-system';

export default function OldPageSubtitle({ children, ...rest }) {
  return (
    <Box sx={{ textAlign: 'center', marginTop: 3 }}>
      <Text>{children}</Text>
    </Box>
  );
}
